<template>
  <div ref="root" class="container-menu sticky no-print">
    <header class="m-0">
      <nav class="menu-sticky">
        <b-container class="container-menu-bottom">
          <b-row class="d-flex">
            <b-col cols="10" class="pl-0">

              <ul class="menu-inferior" v-if="!isManutPage()">
                <li class="pr-2">
                  <router-link to="/">
                    <img
                      width="200"
                      class="img-fluid"
                      src="@/assets/images/logo-header.svg"
                      alt="UOL Afiliados"
                    />
                  </router-link>
                </li>
                <li :class="this.selectPage('/')">
                  <a :href="`/app/${queryString}`">Painel</a>
                </li>
                <li :class="this.selectPage('/campanhas')">
                  <router-link :to="{ path: '/campanhas', query: queryObject }">
                    Campanhas
                  </router-link>
                </li>
                <li :class="this.selectPage('/relatorios')">
                  <router-link
                    :to="{ path: '/relatorios', query: queryObject }"
                  >
                    Relatórios
                  </router-link>
                </li>
                <li><a :href="`/extrato.html${queryString}`">Extrato</a></li>
                <li><a :href="`/sites.html${queryString}`">Sites</a></li>
                <li :class="this.selectPage('/contato')">
                  <router-link :to="{ path: '/contato', query: queryObject }">
                    Contato
                  </router-link>
                </li>
                <li>
                  <a :href="`/dados-de-recebimento.html${queryString}`">
                    Dados de recebimento
                  </a>
                </li>
                <li :class="this.selectPage('/social-media-insights')" v-if="isInsightsAffiliated()">
                  <router-link
                    :to="{ path: '/social-media-insights', query: queryObject }"
                  >
                    Social Media Insights
                  </router-link>
                </li>
              </ul>

              <ul v-if="isManutPage()">
                <li class="pr-2">
                  <router-link to="#" style="pointer-events: none;">
                    <img
                      width="200"
                      class="img-fluid"
                      src="@/assets/images/logo-header.svg"
                      alt="UOL Afiliados"
                    />
                  </router-link>
                </li>
              </ul>

            </b-col>
            <b-col cols="2" class="d-flex align-items-center">
              <a
                href="https://conta.uol.com.br/logout?dest=http%3A%2F%2Fafiliados.uol.com.br%2Findex.html"
                class="btn outline w-100"
              >
                Sair do painel
              </a>
            </b-col>
          </b-row>
        </b-container>
      </nav>
    </header>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'MenuDesktop',
  data() {
    return {
      queryString: '',
      queryObject: {},
    };
  },
  computed: {
    ...mapGetters(['affiliateInfo']),
  },
  methods: {
    ...mapActions(['fetchAffiliateData']),
    selectPage(path) {
      return this.$route.path === path ? 'active' : undefined;
    },
    isManutPage() {
      return this.$route.path === '/manutencao';
    },
    handleScroll() {
      const distanceTop = document.documentElement.scrollTop;
      const top = this.$refs.root.offsetHeight;
      const stickMenu = document.querySelector('.sticky');
      const body = document.querySelector('body');

      if (distanceTop > top) {
        body.style.marginTop = `${top}px`;
        stickMenu.style.position = 'fixed';
        stickMenu.style.top = '0';
        stickMenu.style.width = '100%';
        stickMenu.style.zIndex = '99';
      } else {
        body.style.marginTop = 0;
        stickMenu.style.position = 'inherit';
      }
    },
    isInsightsAffiliated() {
      return this.affiliateInfo && (this.affiliateInfo.idtPerson === '618775921');
    },
  },
  async created() {
    this.fetchAffiliateData();

    this.queryString = window.location.search;
    const queryObject = {};
    this.queryString
      .substr(1)
      .split('&')
      .forEach((_param) => {
        const param = _param.split('=');
        const key = param.shift();
        const value = param.shift();
        queryObject[key] = value;
      });
    this.queryObject = queryObject;

    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
header {
  background-color: $bg-light;
  color: $text-light;
  width: 100%;
  -webkit-box-shadow: 0 2px 2px 0 rgba(89, 89, 89, 0.67);
  -moz-box-shadow: 0 2px 2px 0 rgba(89, 89, 89, 0.67);
  box-shadow: 0 2px 2px 0 rgba(89, 89, 89, 0.67);
  z-index: 69;
  font-family: UOLText, Helvetica, sans-serif;
  color: white;
  margin-bottom: 10px;
}

.menu-inferior {
  display: flex;
  align-items: center;
  height: 60px;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul li a {
  color: white;
  @include text-size-small();
  padding: 19px 0;
  text-decoration: none;
}

.logo-uol {
  margin: auto;
}

.container-menu-topo {
  border-bottom: 2px solid rgba(255, 255, 255, 0.15);
}

.container-menu-bottom ul li {
  display: flex;

  a {
    font-size: $font-size-smaller;
    padding: 0 10px;
    height: 100%;
    width: 100%;
    line-height: 60px;
    white-space: nowrap;
  }

  &:hover:not(:first-child),
  &.active {
    border-top: 2px solid white;
    background-color: #d87520;
    margin-top: -2px;
    height: 62px;
  }
}

.outline {
  height: 34px;
  line-height: 32px;
  border: 1px solid white;
  color: white;
  padding: 0 20px;
  border-radius: none;
  @include text-size-small();
}

@media screen and (max-width: $lg - 1px) {
  .container-menu {
    display: none;
  }
}
</style>
